import Alpine from 'alpinejs'
import imageIn from './x-image-in'
import recaptcha from './x-recaptcha'
import scrollTo from './x-scroll-to'
import selectAutosize from './x-select-autosize'
import reveal from './x-reveal'
import tooltip from './x-tooltip'

export default function register() {
  Alpine.directive('image-in', imageIn)
  Alpine.directive('recaptcha', recaptcha)
  Alpine.directive('scroll-to', scrollTo)
  Alpine.directive('select-autosize', selectAutosize)
  Alpine.directive('reveal', reveal)
  Alpine.directive('tooltip', tooltip)
}
